function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Star from "./star";
import cx from "classnames";
var classPrefix = "tc-score";
var Score = function Score(props) {
  var wrapClassName = props.wrapClassName,
    color = props.color,
    size = props.size,
    className = props.className,
    _props$amount = props.amount,
    amount = _props$amount === void 0 ? 5 : _props$amount,
    grounding = props.grounding,
    colors = props.colors,
    score = props.score,
    onChange = props.onChange,
    _props$percent = props.percent,
    percent = _props$percent === void 0 ? 5 : _props$percent,
    style = props.style,
    width = props.width;
  var average = parseInt("".concat(percent / amount));
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    progress = _useState2[0],
    setProgress = _useState2[1];
  var baseProps = {
    className: cx(classPrefix, wrapClassName, "".concat(classPrefix, "-").concat(size)),
    style: style
  };
  useEffect(function () {
    var arr = [];
    var scoreCount = score || 0;
    for (var i = 0; i < amount; i++) {
      var lastCount = scoreCount >= average ? 100 : scoreCount <= 0 ? 0 : scoreCount / average * 100;
      scoreCount = scoreCount - average;
      arr.push(parseInt("".concat(lastCount)));
    }
    setProgress(arr);
  }, [score, amount, average]);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), Array.isArray(Array(progress)) && progress.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      // eslint-disable-next-line react/no-array-index-key
      key: item + index,
      onClick: function onClick() {
        if (!!onChange) {
          var place = index + 1;
          var placeFixed = ~~place.toFixed(0);
          onChange(average * placeFixed);
        }
      }
    }, /*#__PURE__*/React.createElement(Star, {
      grounding: grounding,
      progress: progress[index],
      size: size,
      color: !!colors ? colors[index] : color,
      className: className,
      style: {
        "--width": width
      }
    }));
  }));
};
Score.defaultProps = {
  size: "small",
  color: "#F7B500",
  grounding: "#E0E0E0",
  score: 0,
  amount: 5,
  percent: 5
};
export default Score;